/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {useState} from "react";
import {useIsPresent} from "motion/react";

export default function UnmountOnExit({children, delay = 500}) {
    const [unmountChild, setUnmountChild] = useState(false);
    const isPresent = useIsPresent()

    // useEffect(() => {
    //     // on mount rest
    //     setUnmountChild(false);
    //     if (!isPresent) {
    //         const timer = setTimeout(() => {
    //             if (!isPresent) {
    //                 setUnmountChild(true);
    //             }
    //         }, delay);
    //         return () => clearTimeout(timer);
    //     }
    //
    // }, [isPresent, delay]);
    //
    //
    //
    // if (unmountChild) {
    //     return <div></div>
    // }

    return <div
        className={`w-full h-full ${!isPresent ? ("pointer-events-none transition-opacity delay-5000 opacity-0") : ""}`}>{children}</div>
}
